import React, { useState, useEffect } from 'react';

function App() {
  const [name, setName] = useState('');
  const [file, setFile] = useState(null);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL || '';

  const fetchEntries = async () => {
    const res = await fetch(`${apiUrl}/api/entries`);
    const data = await res.json();
    setEntries(data);
  };

  useEffect(() => {
    fetchEntries();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !file) return;
    setLoading(true);
    const formData = new FormData();
    formData.append('name', name);
    formData.append('file', file);
    await fetch(`${apiUrl}/api/upload`, {
      method: 'POST',
      body: formData,
    });
    setName('');
    setFile(null);
    await fetchEntries();
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 400, margin: '40px auto', fontFamily: 'Arial' }}>
      <h2>Subir Nombre y Archivo</h2>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <input
          type="text"
          placeholder="Nombre"
          value={name}
          onChange={e => setName(e.target.value)}
        />
        <input
          type="file"
          onChange={e => setFile(e.target.files[0])}
        />
        <button type="submit" disabled={loading}>{loading ? 'Subiendo...' : 'Subir'}</button>
      </form>
      <hr />
      <h3>Lista de Archivos Subidos</h3>
      <ul>
        {entries.map((entry, idx) => (
          <li key={idx}>
            <b>{entry.name}</b> - <a href={`${apiUrl}/uploads/${entry.filename}`} target="_blank" rel="noopener noreferrer">{entry.originalname}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default App;
